import { render, staticRenderFns } from "./DefinitionCustomerDeviceRequest.vue?vue&type=template&id=55191b0e&"
import script from "./DefinitionCustomerDeviceRequest.vue?vue&type=script&lang=js&"
export * from "./DefinitionCustomerDeviceRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports